import { Mesh, Object3D } from '@seddi/three';

export const filterMeshes = (root: Object3D): Mesh[] => {
  const meshes = [];
  const nodes = [root];
  let i = 0;

  // Visit hierarchy of nodes looking for Mesh objects
  while (i < nodes.length) {
    const object = nodes[i];

    if ((object as any).isMesh) {
      meshes.push(object as Mesh);
    }

    nodes.push(...object.children);
    i++;
  }

  return meshes;
};
